/**
 * 지면의 날짜 표기.
 *
 * 서식류에 쓰는 표기(2026. 9. 10.)와 본문에 쓰는 표기(2026년 9월 10일)를
 * 나눠 둔다. 인쇄물에서 이 둘은 쓰임이 다르다.
 */

function parse(value) {
  if (!value) return null;
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** 본문·판권용. "2026년 9월 10일" / "September 10, 2026" */
export function formatDate(value, lang = "ko") {
  const date = parse(value);
  if (!date) return value || "";

  if (lang === "en") {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
}

/** 발행 후 이 기간 안의 글에 목록에서 NEW 표시를 붙인다. */
export const NEW_DAYS = 30;

const DAY = 24 * 60 * 60 * 1000;

/** 발행일이 NEW_DAYS 일 안쪽인가. 날짜를 읽을 수 없으면 false. */
export function isNew(value, now = new Date()) {
  const date = parse(value);
  if (!date) return false;
  return now.getTime() - date.getTime() < NEW_DAYS * DAY;
}

/** 목차·서식표용. 숫자를 세로로 맞춰 읽는 자리. "2026. 09. 10." / "2026.09.10" */
export function formatFiling(value, lang = "ko") {
  const date = parse(value);
  if (!date) return value || "";

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");

  return lang === "en" ? `${y}.${m}.${d}` : `${y}. ${m}. ${d}.`;
}
